import angular from "angular";

angular.module("folkeuni").factory("UserApi", function ($http) {
  var self = this;
  var apiBase = "/api/customer/";

  self.exists = function (siteId, email) {
    return $http({
      method: "get",
      url: apiBase + "exist?siteId=" + siteId + "&email=" + email,
    });
  };

  self.validate = function (userObj) {
    console.dir(userObj);
    return $http({
      method: "post",
      data: userObj,
      url: apiBase + "validate",
    });
  };

  self.activate = function (userObj) {
    return $http({
      data: userObj,
      method: "post",
      url: apiBase + "activate",
    });
  };

  self.cprUpdate = function (cpr) {
    return $http({
      method: "put",
      data: '"' + cpr + '"',
      url: apiBase + "cpr",
    });
  };

  self.create = function (userObj) {
    return $http({
      data: userObj,
      method: "post",
      url: apiBase,
    });
  };

  self.getCurrent = function () {
    return $http({
      method: "get",
      url: apiBase,
    });
  };

  self.login = function (userObj) {
    return $http({
      method: "post",
      data: userObj,
      url: apiBase + "login",
    });
  };

  self.passwordForgot = function (emailObj) {
    return $http({
      data: emailObj,
      method: "post",
      url: apiBase + "forgotpassword",
    });
  };

  self.passwordReset = function (passwordObj) {
    return $http({
      data: passwordObj,
      method: "post",
      url: apiBase + "resetpassword",
    });
  };

  self.update = function (userObj) {
    return $http({
      method: "put",
      data: userObj,
      url: apiBase,
    });
  };

  return self;
});
